import { motion } from 'framer-motion';

const PolicyComparison = () => {
  const comparisonData = [
    {
      dimension: "是否需要进项",
      mode1039: { text: "无需进项发票", highlight: true },
      general: { text: "必须有进项", highlight: false },
      crossBorder: { text: "无需进项", highlight: false }
    },
    {
      dimension: "是否可多品类",
      mode1039: { text: "支持混装", highlight: true },
      general: { text: "单一品类为主", highlight: false },
      crossBorder: { text: "限制较多", highlight: false }
    },
    {
      dimension: "税务处理方式",
      mode1039: { text: "免征增值税", highlight: true },
      general: { text: "正常征税退税", highlight: false },
      crossBorder: { text: "按政策执行", highlight: false }
    },
    {
      dimension: "单票金额限制",
      mode1039: { text: "≤15万美元", highlight: true },
      general: { text: "无限制", highlight: false },
      crossBorder: { text: "通常较小", highlight: false }
    },
    {
      dimension: "合规成本",
      mode1039: { text: "中等", highlight: true },
      general: { text: "较高", highlight: false },
      crossBorder: { text: "较低", highlight: false }
    },
    {
      dimension: "适用企业规模",
      mode1039: { text: "中小企业友好", highlight: true },
      general: { text: "大中型企业", highlight: false },
      crossBorder: { text: "小微企业", highlight: false }
    },
    {
      dimension: "收汇便利性",
      mode1039: { text: "代收外汇", highlight: true },
      general: { text: "自行收汇", highlight: false },
      crossBorder: { text: "平台代收", highlight: false }
    },
    {
      dimension: "监管要求",
      mode1039: { text: "规范化监管", highlight: true },
      general: { text: "严格监管", highlight: false },
      crossBorder: { text: "平台监管", highlight: false }
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-primary mb-4">出口模式对比</h2>
          <p className="text-gray-600 text-lg">帮您选择最适合的出口方式</p>
        </motion.div>

        <div className="overflow-x-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="min-w-[800px]"
          >
            <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
              <thead>
                <tr className="bg-gradient-to-r from-primary to-primary-dark text-white">
                  <th className="px-6 py-4 text-left font-semibold">对比维度</th>
                  <th className="px-6 py-4 text-center font-semibold relative">
                    <div className="flex items-center justify-center gap-2">
                      <span>市场采购贸易1039</span>
                      <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full animate-pulse"></div>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-center font-semibold opacity-70">一般贸易</th>
                  <th className="px-6 py-4 text-center font-semibold opacity-70">跨境电商</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, index) => (
                  <motion.tr
                    key={index}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: index * 0.05 }}
                    className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                      index % 2 === 0 ? 'bg-gray-50/50' : 'bg-white'
                    }`}
                  >
                    <td className="px-6 py-4 font-medium text-gray-700">{row.dimension}</td>
                    <td className="px-6 py-4 text-center">
                      <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full ${
                        row.mode1039.highlight 
                          ? 'bg-accent/20 text-accent font-semibold border border-accent/30' 
                          : 'text-gray-600'
                      }`}>
                        {row.mode1039.highlight && <i className="ri-star-fill text-accent"></i>}
                        <span>{row.mode1039.text}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center text-gray-500">{row.general.text}</td>
                    <td className="px-6 py-4 text-center text-gray-500">{row.crossBorder.text}</td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </motion.div>
        </div>

        {/* 对比总结 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 grid md:grid-cols-3 gap-6"
        >
          <div className="text-center p-6 bg-gradient-to-br from-accent/10 to-accent/5 rounded-xl border border-accent/20">
            <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-accent text-xl"></i>
            </div>
            <h3 className="font-semibold text-primary mb-2">1039模式优势</h3>
            <p className="text-gray-600 text-sm">
              无票出口、多品类混装、税务优惠、中小企业友好
            </p>
          </div>

          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-line text-gray-500 text-xl"></i>
            </div>
            <h3 className="font-medium text-gray-700 mb-2">一般贸易特点</h3>
            <p className="text-gray-500 text-sm">
              适合大宗贸易、需要完整财务链条、退税政策
            </p>
          </div>

          <div className="text-center p-6 bg-gray-50 rounded-xl">
            <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-smartphone-line text-gray-500 text-xl"></i>
            </div>
            <h3 className="font-medium text-gray-700 mb-2">跨境电商特点</h3>
            <p className="text-gray-500 text-sm">
              适合C端销售、依赖电商平台、单件价值较低
            </p>
          </div>
        </motion.div>

        {/* 选择建议 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-12 bg-gradient-to-r from-primary/5 to-accent/5 rounded-xl p-8 border border-primary/10"
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-compass-line text-accent text-xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-primary mb-3">选择建议</h3>
              <div className="space-y-2 text-gray-700">
                <p>• <strong>选择1039：</strong>如果您是中小贸易商，商品多样化，缺少进项票，希望税务优惠</p>
                <p>• <strong>选择一般贸易：</strong>如果您是大型企业，单一品类大批量，有完整供应链体系</p>
                <p>• <strong>选择跨境电商：</strong>如果您主要做C端零售，依赖电商平台，单品价值较低</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PolicyComparison;